__turbopack_context__.v({
  "Spotify": "shared-module-scss-module__mwgIya__Spotify",
  "Vimeo": "shared-module-scss-module__mwgIya__Vimeo",
  "YouTube": "shared-module-scss-module__mwgIya__YouTube",
  "allDays": "shared-module-scss-module__mwgIya__allDays",
  "back_chevron": "shared-module-scss-module__mwgIya__back_chevron",
  "back_link": "shared-module-scss-module__mwgIya__back_link",
  "chevron": "shared-module-scss-module__mwgIya__chevron",
  "copy": "shared-module-scss-module__mwgIya__copy",
  "dayLabel": "shared-module-scss-module__mwgIya__dayLabel",
  "desktop_only": "shared-module-scss-module__mwgIya__desktop_only",
  "embed": "shared-module-scss-module__mwgIya__embed",
  "embedSlide": "shared-module-scss-module__mwgIya__embedSlide",
  "filterButtonsContainer": "shared-module-scss-module__mwgIya__filterButtonsContainer",
  "filters": "shared-module-scss-module__mwgIya__filters",
  "fullWidthMobile": "shared-module-scss-module__mwgIya__fullWidthMobile",
  "h1": "shared-module-scss-module__mwgIya__h1",
  "highlighted": "shared-module-scss-module__mwgIya__highlighted",
  "hoverBg": "shared-module-scss-module__mwgIya__hoverBg",
  "hoverLink": "shared-module-scss-module__mwgIya__hoverLink",
  "hoverText": "shared-module-scss-module__mwgIya__hoverText",
  "item": "shared-module-scss-module__mwgIya__item",
  "label": "shared-module-scss-module__mwgIya__label",
  "label_wrap": "shared-module-scss-module__mwgIya__label_wrap",
  "left": "shared-module-scss-module__mwgIya__left",
  "link": "shared-module-scss-module__mwgIya__link",
  "mobile_only": "shared-module-scss-module__mwgIya__mobile_only",
  "pinkText": "shared-module-scss-module__mwgIya__pinkText",
  "top": "shared-module-scss-module__mwgIya__top",
  "video": "shared-module-scss-module__mwgIya__video",
  "whiteButton": "shared-module-scss-module__mwgIya__whiteButton",
  "wrapper": "shared-module-scss-module__mwgIya__wrapper",
});
